module.exports = __webpack_public_path__ + "assets/img/kv-39397277.jpg";